<template>
  <div class="container_shadow">
    <img
      class="close"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_close_icon.png"
      alt
      @click="close"
    />

    <img
      class="good"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_good_icon.png"
      alt
    />
    <div class="coupon_box">
      <div class="left1" v-if="couponInfo.discountType == 2">
        <div class="left_num1">{{couponInfo.discountAmount}}</div>
        <div class="left_unit1">折</div>
      </div>

      <div class="left2" v-if="couponInfo.discountType == 1">
        <div class="left_num2">{{couponInfo.discountAmount}}</div>
        <div class="left_unit2">元</div>
      </div>
      <div class="right">
        <div class="right_title">{{couponInfo.couponName}}</div>
        <div class="right_tip" v-if="couponInfo.productionFitType != 1">指定产品可用</div>
      </div>
    </div>

    <div class="bottom_box">
      <div class="btn" @click="goCouponPage">立即前往选课</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reqCouponInfo } from '@/api/coupon';
import { reqCouponList } from '@/api/newUser';

export default {
  props: {
    couponId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      couponInfo: {},
    };
  },
  computed: {
    ...mapState(['userInfo', 'allAcvitity']),
  },
  mounted() {
    console.log('this.couponId', this.couponId, this.allAcvitity);
    const { couponVersion } = this.allAcvitity.nowAcvitity;
    const userId = this.userInfo?.id;

    if (!this.couponId) return;
    reqCouponList(`couponId=${this.couponId}`).then(res => {
      console.log(res, '详情');
      const { discountType, discountAmount, productionFitType, couponName } = res.data?.[0] || {};
      this.couponInfo = {
        discountAmount,
        discountType,
        productionFitType,
        couponName,
      };
    });
    // console.log(this.couponInfo, 'couponInfo');
  },
  methods: {
    close() {
      PubSub.publish('global_coupon_succ_modal', {
        couponVisible: false,
      });
    },
    goCouponPage() {
      this.close();
      this.$router.push({
        path: '/personalCenter/myCoupon',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container_shadow {
  position: fixed;
  z-index: 1000;
  background: rgba($color: #000000, $alpha: 0.7);
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;

  .close {
    position: absolute;
    z-index: 1;
    display: block;
    height: 43px;
    width: 43px;
    bottom: 673px;
    right: 36px;
  }

  .good {
    position: absolute;
    z-index: 1;
    display: block;
    height: 288px;
    width: 750px;
    left: 0;
    bottom: 384px;
  }

  .coupon_box {
    position: absolute;
    z-index: 2;
    width: 678px;
    height: 221px;
    background: #ffffff;
    border-radius: 36px;
    left: 36px;
    bottom: 214px;
    display: flex;
    align-items: center;
    justify-content: center;

    .left1 {
      height: 163px;
      width: 230px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_left_icon.png')
        no-repeat;
      background-size: cover;

      .left_num1 {
        float: left;
        height: 127px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 91px;
        color: #fd511e;
        line-height: 127px;
        margin-top: 18px;
        margin-left: 54px;
      }

      .left_unit1 {
        float: left;
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 36px;
        color: #fd511e;
        line-height: 51px;
        margin-top: 70px;
        margin-left: 3px;
      }
    }

    .left2 {
      height: 163px;
      width: 230px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_left_icon.png')
        no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 26px;

      .left_num2 {
        height: 76px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 54px;
        color: #fd511e;
        line-height: 76px;
      }

      .left_unit2 {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 36px;
        color: #fd511e;
        line-height: 60px;
      }
    }

    .right {
      height: 163px;
      width: 390px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coupon/coupon_right_icon.png')
        no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 5px;

      .right_title {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 36px;
        color: #702f03;
        line-height: 51px;
        margin-left: 7px;
      }
      .right_tip {
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #c1a262;
        line-height: 36px;
        margin-left: 7px;
      }
    }
  }
  .bottom_box {
    position: absolute;
    z-index: 1;
    width: 750px;
    height: 384px;
    background: #ffffff;
    left: 0;
    bottom: 0;

    .btn {
      width: 620px;
      height: 91px;
      background: linear-gradient(90deg, #ff4e02 0%, #ff9b31 100%);
      border-radius: 45px;
      line-height: 91px;
      font-weight: 500;
      font-size: 29px;
      color: #ffffff;
      text-align: center;
      margin: 196px auto 0;
    }
  }
}
</style>